import React, { Component } from 'react';
import { Container } from './common'
import MainPage from './MainPage';
import './boy.css'


class MainContainer extends Component{
   state = {
            names:{ "name-01": {
                    id: "name-01",
                    name: "Psalm",
                    sex: "girl",
                    meaning: "Song",
                    origin: "USA",
                    likes: "1000k",
                    views: 3000,
                    title: "Frank",
                    body: " We are awesome like that" },
                    "name-02": {
                    id: "name-02",
                    name: "Jude",
                    sex: "boy",
                    meaning: "Praise",
                    origin: "Isreal",
                    likes: 6000,
                    views: 3000,
                    title: "Frank",
                    body: " We are awesome like that"},
                    "name-03": {
                    id: "name-03",
                    name: "Nangoli",
                    sex: "girl",
                    meaning: "Blessed one",
                    origin: "Uganda",
                    likes: 1000,
                    views: 3000,
                    title: "Frank",
                    body: " We are awesome like that" },
                   "name-04": {
                    id: "name-04",
                    name: "Ariana",
                    sex: "girl",
                    meaning: "Holy one",
                    origin: "Greece",
                    likes: 9000,
                    views: 3000,
                    title: "Frank",
                    body: " We are awesome like that" },
                    "name-05":{
                     id: "name-05",
                    name: "Nuru",
                    sex: "boy",
                    meaning: "Born at night",
                    origin: "Egypt",
                    likes: 8000,
                    views: 3000,
                    title: "Frank",
                    body: " We are awesome like that" },
                   "name-06":{
                    id: "name-06",
                    name: "Michael",
                    sex: "girl",
                    meaning: "who is like God",
                    origin: "Isreal",
                    likes: 700,
                    views: 3000,
                    title: "Frank",
                    body: " We are awesome like that" },
                    "name-07":{
                    id: "name-07",
                    name: "Eric",
                    sex: "boy",
                     meaning: "Ever or eternal ruler",
                    origin: "Scandinavia",
                    likes: 200,
                     views: 3000,
                     title: "Frank",
                    body: " We are awesome like that"},
                    "name-08":{
                    id: "name-08",
                    name: "masaba",
                    sex: "girl",
                    meaning: "Born at the mountain",
                    origin: "Uganda",
                    likes: "500,000",
                    views: 3000,
                    title: "Frank",
                    body: " We are awesome like that" },
                     "name-09":{
                    id: "name-09",
                    name: "Mary",
                    sex: "girl",
                    meaning: "Wished-for child, rebellion, bitter",
                    origin: " Isreal",
                    likes: 3000,
                    views: 3000,
                    title: "Frank",
                    body: " We are awesome like that"}
                },
                   currentName: {
                   id: " ",
                   name: "Psalm",
                   sex: "girl",
                   meaning: "Song",
                   origin: "Isreal",
                   likes: 3000,
                   views: "10,000",
                   title: " ",
                   body: " "},
                   favourites: [],
                   options: [{}],
                }
    
    
setCurrentName = (name)=>{ this.setState({ currentName: name })}

addFavourites=(name)=>{ 
     const list = this.state.favourites.concat([name])
     this.setState({ favourites: list + " " })
    }

render(){
      return(
            <Container>
                <MainPage names={this.state.names}
              currentName={this.state.currentName}
              setCurrentName={this.setCurrentName}
              addFavourites = {this.addFavourites}
                favourites={this.state.favourites}
                />
            </Container>
            )
        }
    };

export {MainContainer};


// WEBPACK FOOTER //
// ./src/components/MainContainer.js